export const environment = {
  lang: 'en',
  url: 'https://holidaycountdownapp.com/',
};
